import Loader from "react-loader-spinner";
import { faCalendar, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import { Modal, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerEvents } from "../store/api/CustomerApi";

const ModalServiceEvents = (props) => {
    const dispatch = useDispatch();
    const { popData, setPopData } = props;
    const { ServiceID, ServiceType, show } = popData;
    const { list } = useSelector(state => { return { list: state.customerDataReducer.customerEventList } });
    function close() {
        setPopData({
            show: false
        })
    }
    useEffect(() => {
        if (Number(ServiceID) > 0) {
            const data = {
                AttachmentID: ServiceID,
                AttachmentType: ServiceType
            }
            dispatch(getCustomerEvents(data))
        }

    }, [ServiceID, ServiceType])
    return (
        <Modal show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faCalendar}/>&nbsp;
                رویدادهای سرویس
                </span>
                <FontAwesomeIcon icon={faTimes} onClick={close} size="lg"/>
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <Table>
                    <thead>
                        <tr>
                            <th>تاریخ رویداد</th>
                            <th>شرح رویداد</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list === "PENDING" &&
                            <tr>
                                <td colSpan={2} style={{ width: "100%", textAlign: "center", height:"auto" }}><Loader type="BallTriangle" width={25} hegith={25} color="#bb1370" />
                                </td>
                            </tr>
                        }
                        {list?.Message &&
                            <tr>
                                <td colSpan={2} style={{ color:"red" }}>اشکال در دریافت اطلاعات از سرور</td>
                            </tr>
                        }
                        {
                            list?.Data && Array.isArray(list.Data) &&
                            list.Data.map((item,i)=>
                            <tr key={i} className="resultTableRow">
                                <td style={{width:"105px"}}>{item.PCreationDate}</td>
                                <td>{item.Description}</td>
                            </tr>)
                        }
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    )
}
export default ModalServiceEvents;